import About from "../components/Home/About"
import Navbar from "../components/Home/Navbar"
import Services from "../components/Home/Services"
import Button from "../components/Widgets/Button"
import Coaching from "../components/Home/Coaching"
import Process from "../components/Home/Process"
import ScrollLink from "../components/Widgets/ScrollLink"
import FAQs from "../components/Home/FAQs"
import Testimonials from "../components/Home/Testimonials"
import Footer from "../components/Footer"
import CalendlyButton from "../components/Widgets/CalendlyButton"
import ScrollUpButton from "../components/Widgets/ScrollUpButton"
import socialIcons from "../components/Icons/SocialIcons"
import { headlinks } from "../utilities/links"
import { slides } from "../utilities/home"
import "react-responsive-carousel/lib/styles/carousel.min.css"
import { useLayoutEffect, useRef, useState } from "react"
import gsap from "gsap"
import './index.scss'

const Home = () => {
	const main = useRef(null);
	const [currentSlideIndex, setCurrentSlideIndex] = useState(0)
	useLayoutEffect(() => {

		const slidesInterval = setInterval(() => {
			setCurrentSlideIndex((i) => ((i + 1) % slides.length));
		}, 5000);

		let ctx = gsap.context(() => {
			gsap.from(".topBottom", { y: -100, duration: .7, opacity: .1 })
			gsap.from(".bottomUp", { y: 100, duration: .7, opacity: .1 })
		}, main);

		return () => {
			ctx.revert();
			clearInterval(slidesInterval)
		};
	}, [])


	return (
		<div ref={main}>
			<Navbar links={headlinks} />
			<section id="home" className="relative">
				{/* <Carousel
					className="top-carousel"
					showThumbs={false}
					infiniteLoop
					// interval={1000}
					autoPlay
					transitionTime={1000}
					animationHandler={'fade'}
					autoFocus
					// emulateTouch
					showStatus={false}
					showArrows={false}
				// showIndicators={false}
				> */}
				{slides.map(({ bgImg, heading, subs }, i) => (
					i === currentSlideIndex &&
					<div key={i} className="h-screen relative custom-slide">
						<div style={{ backgroundImage: `url('${bgImg}')` }} className={`absolute inset-0 -scale-x-100 bg-cover transition-all bg-center duration-700 ease-in-out`}></div>
						<div className='inset-0 absolute bg-[#161c2dbf] opacity-90'></div>
						<div className='flex h-full flex-col text-left relative'>
							<div className='my-auto app-x pt-20 flex'>
								<div>
									<h3 className='topBottom font-serif font-extrabold text-white text-[2.5rem] md:text-5xl'>{heading}</h3>
									<div className='bottomUp text-slate-300 font-sans mt-4 mb-1 max-w-xl text-md selection:text-slate-500'>
										{subs.map((each, i) => (
											<p key={i} className="mb-3">{each}</p>
										))}
									</div>
									<ScrollLink className="bottomUp" to="about" scrollOn="/">
										<button className='h-10 w-10 bottomUp text-white pb-1 pt-2  px-3 focus:outline-none focus-visible:ring ring-slate-300 rounded-full bg-primary '>
											<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-full h-full animate-bounce">
												<path strokeLinecap="round" strokeLinejoin="round" d="M19.5 13.5L12 21m0 0l-7.5-7.5M12 21V3" />
											</svg>
										</button>
									</ScrollLink>
								</div>
								<div className="hidden md:flex flex-col space-y-3 ml-auto text-slate-300">
									{socialIcons.map(({ icon, link }, i) => (
										<a key={i} href={link} target="_blank" rel="noreferrer" className="border border-slate-400 hover:border-none hover:text-white hover:bg-primary focused transition-all duration-200 rounded-md h-7 w-7 flex justify-center items-center p-1">
											{icon}
										</a>
									))}
								</div>
							</div>
						</div>
					</div>
				))}
				<div className="flex space-x-4 w-fit mx-auto absolute bottom-4 left-0 right-0">
					{
						Array.from(Array(slides.length).keys())
							.map((each, i) => (
								<button key={i}
									onClick={() => setCurrentSlideIndex(i)}
									className={`${i === currentSlideIndex ? 'bg-white' : 'bg-slate-400'} rounded-full h-2 w-2 focused transition`}>
								</button>
							))
					}
				</div>
				{/* </Carousel> */}

			</section>
			<About />
			<Services />
			<section className="bg-cover relative bg-center bg-[url('https://images.unsplash.com/flagged/photo-1564445477052-8a3787406bbf?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxzZWFyY2h8MTF8fHR1dG9yfGVufDB8MHwwfHw%3D&auto=format&fit=crop&w=1400&q=60')]">
				<div className='inset-0 bg-[#161c2dd7] opacity-90 absolute'></div>
				<div className='m-auto md:px-24 py-20 px-10 text-center flex flex-col items-center relative max-w-4xl'>
					<h3 className='font-serif text-3xl sm:text-5xl font-extrabold text-tan'>
						Application for the next program cohort is open.
					</h3>
					<p className='text-slate-300 font-sans max-w-md selection:text-slate-500 py-8'>Our coaching programs are done in cohorts and each program offers once-a-week 1-hour session over a period of 8 weeks.</p>
					<CalendlyButton>
						<Button text="Book a discovery call" primary />
					</CalendlyButton>
				</div>
			</section>
			<Coaching />
			<Process />
			<Testimonials />
			<FAQs />
			<section className="relative py-10">
				<div className='m-auto md:px-24 p-10 text-center flex flex-col items-center relative max-w-4xl'>
					<h3 className='font-serif text-3xl sm:text-5xl font-extrabold text-slate-700'>
						Let's Get Started!
					</h3>
					<p className='text-slate-600 font-sans max-w-md py-5'>We are ready to make our SMARTA MAGIC whenever you are!</p>
					<div className="text-slate-700 flex space-x-4">
						{socialIcons.map(({ icon, link }, i) => (
							<a key={i} href={link} target="_blank" rel="noreferrer" className="border border-slate-500 hover:border-none hover:text-white hover:bg-primary focused transition-all duration-200 rounded-md h-7 w-7 flex justify-center items-center  p-1">
								{icon}
							</a>
						))}
					</div>
				</div>
			</section>
			<Footer />
			<ScrollUpButton />
		</div>
	)
}

export default Home